import CountUp from "./CountUp";
import "../styles/Count.css";

export default function Count() {
  const counters = [
    { label: "Domain Specializations", to: 10, suffix: "+ Years" },
    { label: "Countries", to: 3 },
    { label: "Projects", to: 100, suffix: "+" },
    { label: "Skilled Manpower", to: 300 , suffix: "+" },
  ];

  return (
    <>
      <div className="count-container">
        {counters.map(({ label, to, suffix }, index) => (
          <div
            key={index}
            className="count-box"
            data-aos="fade-up"
            data-aos-delay={index * 200}
          >
            <span className="count-number">
              <CountUp to={to} separator="," className="inline-count" />
              {suffix && <span>{suffix}</span>}
            </span>
            <p className="count-label">{label}</p>
          </div>
        ))}
      </div>

    <div className="fullwidth-image" />

    </>
  );
}
